import OfflineImage from "components/OfflineImage/OfflineImage";
import { useContext } from "react";

import { MapContext } from "../../../Map/Map";

import styles from "./SearchResultImage.module.scss";
import classNames from "classnames";

export default function SearchResultImage({
  imageUrl,
}: {
  imageUrl: string | null;
}) {
  const { controlTheme } = useContext(MapContext);

  return (
    <div className={classNames(styles.container, styles[controlTheme])}>
      <OfflineImage
        theme={controlTheme}
        data-qa="search-result-image"
        className={styles.image}
        src={imageUrl || undefined}
        alt="search-result"
      />
    </div>
  );
}
